// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__bzGea","label":"Category_label__t6AdI","content":"Category_content__1I07m","header":"Category_header__1ZqUL","location":"Category_location__3k0SK"};